module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA10.3f5f3450.jpg";